module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/singapore/font/notokr-medium.woff
// module id = pCIR
// module chunks = 0